import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React from 'react';

var _excluded = ["className", "color", "title", "size", "testid"];
var PlaceOutlinedIcon = function PlaceOutlinedIcon(_ref) {
  var className = _ref.className,
    color = _ref.color,
    title = _ref.title,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 48 : _ref$size,
    testid = _ref.testid,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color || 'currentColor',
    "data-testid": testid,
    className: className,
    "aria-hidden": "true",
    focusable: "false"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
  }), Boolean(title) && /*#__PURE__*/React.createElement("title", null, title));
};

export { PlaceOutlinedIcon as default };
